import React from 'react';
import Box from '../box';
import { useStyleConfig, vui } from '../core';
import { cs } from '../utils';
import { useFooterContext } from './context';
/** Controls max-width of the content and centers itself horizontally. */
export const FooterContent = vui((props, ref) => {
    const { className, ...rest } = props;
    const styles = useStyleConfig('Footer', useFooterContext());
    return (React.createElement(Box, { className: cs('vui-footerContent', className), column: true, fontSize: { xs: 12, sm: 12, md: 14 }, maxW: { xs: 344, sm: 412, md: 780, lg: 782, xl: 888 }, mx: "auto", ref: ref, w: "100%", ...styles.content, ...rest }));
});
export default FooterContent;
